import { render, staticRenderFns } from "./ContentPrivateConfRegister.vue?vue&type=template&id=3190a8d6"
import script from "./ContentPrivateConfRegister.vue?vue&type=script&lang=js"
export * from "./ContentPrivateConfRegister.vue?vue&type=script&lang=js"
import style0 from "./ContentPrivateConfRegister.vue?vue&type=style&index=0&id=3190a8d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports